/**
 * Reusable pagination helpers for Vuex store modules.
 *
 * Usage in a store:
 *
 *   import { commitPagination, hasNextPage } from "src/store/utils/pagination";
 *
 *   // In a fetchMore* action:
 *   async fetchMoreItems({ commit, state }) {
 *     if (!hasNextPage(state, "itemsPagination")) return;
 *     const nextPage = state.itemsPagination.currentPage + 1;
 *     const response = await getItems(nextPage);
 *     commit("appendItems", response.data.data);
 *     commitPagination(commit, response.data.meta.pagination, {
 *       update: "updateItemsPagination",
 *       setHasMore: "setHasMoreItems",
 *     });
 *   },
 */

/**
 * Returns true when there are more pages to load.
 * @param {object} state - Vuex module state
 * @param {string} paginationKey - name of the pagination state property (e.g. "completedActionsPagination")
 */
export function hasNextPage(state, paginationKey) {
  return state[paginationKey].currentPage < state[paginationKey].total_pages;
}
/**
 * Commits pagination state after a paginated API response.
 * Automatically sets hasMore to false when the last page is reached.
 *
 * @param {Function} commit - Vuex commit function
 * @param {object} pagination - The pagination object from the API response (response.data.meta.pagination)
 * @param {{ update: string, setHasMore: string }} mutations - Mutation names to call
 */

export function commitPagination(commit, pagination, _ref) {
  var update = _ref.update,
      setHasMore = _ref.setHasMore;

  if (pagination) {
    commit(update, {
      currentPage: pagination.current_page,
      total_pages: pagination.total_pages
    });

    if (pagination.current_page >= pagination.total_pages) {
      commit(setHasMore, false);
    }
  } else {
    commit(setHasMore, false);
  }
}